'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _idGen = require('../../utils/idGen');

var _idGen2 = _interopRequireDefault(_idGen);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _AccordionWrapper = require('./AccordionWrapper');

var _AccordionWrapper2 = _interopRequireDefault(_AccordionWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var Accordion = function (_React$Component) {
    _inherits(Accordion, _React$Component);

    function Accordion() {
        _classCallCheck(this, Accordion);

        var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).apply(this, arguments));

        _this.state = { isExpanded: false };
        _this.toggle = function () {
            var _this$props = _this.props,
                controlledExpanded = _this$props.expanded,
                onChange = _this$props.onChange;
            var isExpanded = _this.state.isExpanded;

            if (onChange) {
                onChange(!isExpanded);
            }
            if (controlledExpanded === undefined) {
                _this.setState({
                    isExpanded: !isExpanded
                });
            }
        };
        _this.componentWillReceiveProps = function (_ref) {
            var controlledExpanded = _ref.expanded;

            if (controlledExpanded !== undefined) {
                _this.setState({
                    isExpanded: controlledExpanded
                });
            }
        };
        return _this;
    }

    _createClass(Accordion, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                expanded = _props.expanded,
                defaultExpanded = _props.defaultExpanded;

            this.setState({
                isExpanded: expanded || defaultExpanded || false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                id = _a.id,
                children = _a.children,
                title = _a.title,
                className = _a.className,
                listItem = _a.listItem,
                titleHref = _a.titleHref,
                rest = __rest(_a, ["id", "children", "title", "className", "listItem", "titleHref"]);
            var itemId = id || (0, _idGen2.default)('expander-details');
            var isExpanded = this.state.isExpanded;

            var accordionClassName = (0, _classnames2.default)('luna-accordion', className, {
                'is-open': isExpanded
            });
            return _react2.default.createElement(_AccordionWrapper2.default, { className: accordionClassName, listItem: listItem }, _react2.default.createElement("div", { className: "luna-accordion__summary", onClick: this.toggle, onKeyDown: this.toggle, role: "button" }, _react2.default.createElement("h5", { className: "luna-accordion__heading" }, _react2.default.createElement("button", Object.assign({ type: "button", className: "luna-accordion__action", "aria-expanded": isExpanded, "aria-controls": itemId }, rest), _react2.default.createElement("span", { className: "luna-accordion__title" }, titleHref ? _react2.default.createElement("a", { href: titleHref }, title) : title), _react2.default.createElement(_Icon2.default, { name: isExpanded ? 'chevron-up' : 'chevron-down' })))), isExpanded && _react2.default.createElement("div", { className: "luna-accordion__details", "aria-hidden": !isExpanded, id: itemId }, children));
        }
    }]);

    return Accordion;
}(_react2.default.Component);

Accordion.propTypes = {
    title: _propTypes2.default.string.isRequired
};
Accordion.propTypes = {
    titleHref: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    expanded: _propTypes2.default.bool.isRequired,
    defaultExpanded: _propTypes2.default.bool.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    listItem: _propTypes2.default.bool.isRequired,
    id: _propTypes2.default.string,
    children: _propTypes2.default.node.isRequired
};
Accordion.defaultProps = {
    id: ''
};
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Accordion/Accordion.js